import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import PlayersListPage from 'inside-fifa/pages/players/list-page';
import GenericTablesDataPage from 'inside-fifa/pages/generic-tables/data';
import { InsideFifaBackOfficePaths } from './consts';
import { Navigate } from 'react-router';
import { ALL_INSIDE_FIFA_TEAM_GROUPS } from 'inside-fifa/setup/auth';
import { GenericTablesConfigPage } from '../pages/generic-tables/configurations'

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));

// ==============================|| INSIDE FIFA ROUTING ||============================== //

const InsideFifaRoutes = {
    path: InsideFifaBackOfficePaths.Root,
    errorElement: <MaintenanceError />,
    children: [
        {
            path: '',
            element: (
                <AuthGuard allowedGroups={ALL_INSIDE_FIFA_TEAM_GROUPS}>
                    <MainLayout />
                </AuthGuard>
            ),
            children: [
                {
                    path: '',
                    element: <Navigate to={InsideFifaBackOfficePaths.Players} />,
                },
                {
                    path: InsideFifaBackOfficePaths.Players,
                    element: <PlayersListPage />,
                },
                {
                    path: InsideFifaBackOfficePaths.GenericTablesData,
                    element: <GenericTablesDataPage />,
                },
                {
                    path: InsideFifaBackOfficePaths.GenericTablesConfigs,
                    element: <GenericTablesConfigPage />,
                },
            ],
        },
    ],
};

export default InsideFifaRoutes;
